import { type ColorOptions, getTagStyles } from '@/utils';
import { Tag as AntTag, type TagProps } from 'antd';
import type { FC } from 'react';

type Props = Omit<TagProps, 'color'> & {
  color?: ColorOptions;
  customColor?: string;
};

export const BaseTag: FC<Props> = ({
  color = 'gray',
  customColor,
  style,
  ...props
}) => {
  return (
    <AntTag
      {...props}
      {...(customColor
        ? { color: customColor } // For using custom color
        : {
            style: {
              borderRadius: 4,
              border: '2px solid',
              marginRight: '2px',
              ...getTagStyles(color),
              ...style,
            },
          })}
    />
  );
};
